import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const Nosotros = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-900 via-blue-800 to-blue-700 text-white py-12 md:py-24 pt-24 md:pt-32 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
          <div className="animate-on-scroll transition-all duration-700 opacity-100 translate-y-0">
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6">Sobre Nosotros</h1>
            <p className="text-lg md:text-xl lg:text-2xl text-white/90 max-w-3xl">
              Somos el aliado estratégico en suministros de oficina para empresas en Puebla
            </p>
          </div>
        </div>
      </section>
      
      {/* Nuestra Historia */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div className="animate-on-scroll transition-all duration-700 opacity-100 translate-y-0">
              <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4 md:mb-6">Nuestra Historia</h2>
              <div className="space-y-4 text-gray-700 leading-relaxed text-sm md:text-base">
                <p>
                  <strong className="text-[#2d5a8c]">CX Comercializadora de Puebla</strong> nació con una visión clara: transformar la manera en que las empresas adquieren sus suministros de oficina en la región de Puebla.
                </p>
                <p>
                  Hoy atendemos a diversas&nbsp;en Puebla y zonas aledañas, desde pequeños negocios hasta corporativos de gran escala, ofreciendo una gran variedad de productos&nbsp;y tiempos de entrega acorde a las necesidades de nuestros clientes
                </p>
              </div>
            </div>
            <div className="animate-on-scroll transition-all duration-700 delay-200 order-first md:order-last opacity-100 translate-y-0">
              <img
                alt="Historia CX Comercializadora"
                className="w-full h-[250px] md:h-[400px] object-cover rounded-lg shadow-xl"
                src="https://public.readdy.ai/ai/img_res/766754e93b21113bcec0b7e1011221e8.jpg"
              />
            </div>
          </div>
        </div>
      </section>
      
      {/* Propósito y Dirección */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14 animate-on-scroll transition-all duration-700 opacity-100 translate-y-0">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-3 md:mb-4">Propósito y Dirección</h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              El norte que guía cada decisión y cada entrega que hacemos
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
            <div className="animate-on-scroll transition-all duration-700 bg-white rounded-2xl p-6 md:p-10 shadow-md border border-gray-100 hover:shadow-xl transition-shadow opacity-100 translate-y-0">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#1e3a5f] rounded-xl mb-4 md:mb-6">
                <i className="ri-focus-3-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mb-3 md:mb-4">Nuestra Misión</h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                Ser el <strong className="text-[#2d5a8c]">socio estratégico</strong> de las empresas mexicanas, garantizando el suministro oportuno de insumos de alta calidad para potenciar su productividad y competitividad en el mercado. No solo entregamos productos — entregamos continuidad operativa.
              </p>
            </div>
            
            <div className="animate-on-scroll transition-all duration-700 delay-150 bg-white rounded-2xl p-6 md:p-10 shadow-md border border-gray-100 hover:shadow-xl transition-shadow opacity-100 translate-y-0">
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-[#2d5a8c] rounded-xl mb-4 md:mb-6">
                <i className="ri-eye-line text-xl md:text-2xl text-white"></i>
              </div>
              <h3 className="text-xl md:text-2xl font-bold text-[#1e3a5f] mb-3 md:mb-4">Nuestra Visión</h3>
              <p className="text-gray-600 leading-relaxed text-sm md:text-base">
                Consolidarnos como la <strong className="text-[#2d5a8c]">comercializadora de insumos líder en Puebla</strong>, expandiendo nuestra huella operativa a nivel nacional mediante una red logística innovadora que nos convierta en el referente de suministro para empresas de todo el país.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* Nuestros Valores */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10 md:mb-14 animate-on-scroll transition-all duration-700 opacity-100 translate-y-0">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-3 md:mb-4">Nuestros Valores</h2>
            <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto">
              Los principios que definen cómo trabajamos y cómo te tratamos cada día
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="animate-on-scroll transition-all duration-700 bg-gradient-to-br from-[#1e3a5f] to-[#2d5a8c] rounded-2xl p-6 md:p-8 text-white hover:scale-105 transition-transform cursor-default opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4 md:mb-5">
                <i className="ri-shield-check-line text-2xl text-white"></i>
              </div>
              <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3 leading-snug">Compromiso con la Continuidad</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Entendemos que nuestro suministro es crítico para tu operación. Por eso nos comprometemos a entregas precisas y soluciones inmediatas que nunca te dejen sin lo que necesitas.
              </p>
            </div>
            
            <div className="animate-on-scroll transition-all duration-700 bg-gradient-to-br from-[#1e3a5f] to-[#2d5a8c] rounded-2xl p-6 md:p-8 text-white hover:scale-105 transition-transform cursor-default opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4 md:mb-5">
                <i className="ri-hand-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3 leading-snug">Integridad en el Suministro</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Transparencia y honestidad en cada cotización. Lo que cotizamos es lo que entregamos — sin sorpresas, sin letra chica, con la calidad prometida siempre garantizada.
              </p>
            </div>
            
            <div className="animate-on-scroll transition-all duration-700 bg-gradient-to-br from-[#1e3a5f] to-[#2d5a8c] rounded-2xl p-6 md:p-8 text-white hover:scale-105 transition-transform cursor-default opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4 md:mb-5">
                <i className="ri-flashlight-line text-2xl text-white"></i>
              </div>
              <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3 leading-snug">Agilidad Estratégica</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                Respondemos con rapidez y flexibilidad ante los cambios del mercado. Optimizamos procesos para acortar distancias y llevar tus insumos donde los necesitas, cuando los necesitas.
              </p>
            </div>
            
            <div className="animate-on-scroll transition-all duration-700 bg-gradient-to-br from-[#1e3a5f] to-[#2d5a8c] rounded-2xl p-6 md:p-8 text-white hover:scale-105 transition-transform cursor-default opacity-100 translate-y-0">
              <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl mb-4 md:mb-5">
                <i className="ri-team-line text-2xl text-white"></i>
              </div>
              <h3 className="text-base md:text-lg font-bold mb-2 md:mb-3 leading-snug">Vocación de Servicio B2B</h3>
              <p className="text-white/80 text-sm leading-relaxed">
                No somos solo proveedores, somos aliados estratégicos. Escuchamos, asesoramos y acompañamos a nuestros clientes para que siempre tomen la mejor decisión para su negocio.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      {/* CTA Final */}
      <section className="py-12 md:py-20 bg-gradient-to-br from-slate-50 to-white">
        <div className="max-w-4xl mx-auto px-4 md:px-6 text-center animate-on-scroll transition-all duration-700 opacity-100 translate-y-0">
          <h2 className="text-3xl md:text-4xl font-bold text-[#1e3a5f] mb-4 md:mb-6">¿Listo para trabajar con nosotros?</h2>
          <p className="text-lg md:text-xl text-gray-600 mb-6 md:mb-8">
            Únete a las empresas que confían en CX Comercializadora para sus suministros de oficina
          </p>
          <div className="flex flex-col sm:flex-row flex-wrap gap-4 justify-center">
            <a
              href="https://wa.me/+522228121142?text=Hola,%20quiero%20conocer%20más%20sobre%20CX%20Comercializadora"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold hover:bg-[#20BA5A] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-xl md:text-2xl"></i>
              Contactar por WhatsApp
            </a>
            <Link
              to="/contacto"
              className="inline-flex items-center justify-center gap-2 bg-[#2d5a8c] text-white px-6 md:px-8 py-3 md:py-4 rounded-lg font-semibold hover:bg-[#1e3a5f] transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
            >
              <i className="ri-mail-line text-lg md:text-xl"></i>
              Enviar Mensaje
            </Link>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default Nosotros;